import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Hospital = forwardRef<SVGSVGElement, SvgIconProps>(
  function Hospital(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M11.5 2C7.92 2 5 5.18 5 9.08c0 6.85 6 12.58 6.25 12.82.07.07.16.1.25.1s.18-.03.25-.1c.26-.24 6.25-5.97 6.25-12.82C18 5.18 15.08 2 11.5 2zm3.44 7.92c0 .23-.17.41-.38.41h-1.91v2.09c0 .23-.17.41-.39.41h-1.52c-.21 0-.39-.18-.39-.41v-2.09h-1.9c-.22 0-.4-.18-.4-.41V8.25c0-.23.18-.42.4-.42h1.9V5.75c0-.23.17-.42.39-.42h1.52c.21 0 .39.19.39.42v2.08h1.9c.22 0 .4.19.4.42v1.67z" />
      </SvgIcon>
    )
  },
)

export default Hospital
